import type { BatchRecapViewModel } from '@ovComponents/4-module/widgets/batchRecap/batchRecap.types';
import type { TFunction } from 'i18next';
import type { MappedBatchRecap } from './v2Mappers';

export function translateBatchRecap(
  recap: MappedBatchRecap,
  t: TFunction<['batchRecap', 'portfolioTradingHub']>,
  formatRelativeTime: (dateStr: string) => string,
): BatchRecapViewModel {
  return {
    asOfLabel: t('batchRecap:asOfLast48Hours'),
    summary: {
      batchesRun: {
        value: recap.summary.batchesRun.value,
        description: t('batchRecap:summary.batchesRunDescription'),
      },
      tradesSent: {
        value: recap.summary.tradesSent.value,
        description: t('batchRecap:summary.tradesSentDescription'),
      },
      portfoliosRebalanced: {
        value: recap.summary.portfoliosRebalanced.value,
        description: t('batchRecap:summary.portfoliosRebalancedDescription'),
      },
      failedOrCanceled: {
        value: recap.summary.failedOrCanceled.value,
        description: t('batchRecap:summary.failedOrCanceledDescription'),
      },
    },
    events: recap.events.map((event) => {
      const stateParam = event.descriptionParams?.state;
      return {
        id: event.id,
        eventType: event.eventType,
        description: t(`batchRecap:events.${event.descriptionKey}`, {
          count: Number(event.descriptionParams?.count ?? 0),
          ...event.descriptionParams,
          ...(typeof stateParam === 'string'
            ? {
                state: t(
                  `portfolioTradingHub:bulkTradeRunStates.${stateParam}`,
                ),
              }
            : {}),
        }),
        status: event.status,
        timeElapsedLabel: formatRelativeTime(event.createdAt),
        metrics: event.metrics?.map((metric) => ({
          label: t(`batchRecap:metrics.${metric.labelKey}`, {
            count: metric.value,
          }),
          value: metric.value,
        })),
      };
    }),
  };
}
